import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CloudUploadRegular from './cloud-upload-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CloudUploadRegular {...validProps} />;
}
SvgComponent.iconName = 'cloud-upload-regular';

export const CloudUploadRegularIcon = svgIconWrapper(SvgComponent);
